export enum TrackingQuality {
  None = -1,
  Limited,
  Basic,
  Regular,
  Excellent,
}
